/**
 * Constantes pour les rapports d'état des lieux et photos
 * Synchronisées avec backend/constants/conditionReports.js
 */

// Types de rapports d'état des lieux
export const CONDITION_REPORT_TYPES = {
  PICKUP: 'pickup',
  RETURN: 'return',
  PICKUP_REFUSAL: 'pickup_refusal',
  RETURN_REFUSAL: 'return_refusal'
};

// Actions possibles sur les rapports
export const CONDITION_ACTIONS = {
  CONFIRM: 'confirm',
  REFUSE: 'refuse',
  DISPUTE: 'dispute'
};

// Types de photos pour les rapports d'état
export const PHOTO_TYPES = {
  EQUIPMENT_STATE: 'equipment_state',
  DAMAGE: 'damage',
  ENVIRONMENT: 'environment',
  REFUSAL_PROOF: 'refusal_proof',
  OVERVIEW: 'overview',
  DETAIL: 'detail'
};

// Rôles d'utilisateurs pour les rapports
export const USER_ROLES = {
  OWNER: 'owner',
  RENTER: 'renter'
};

// Statuts des disputes (structure future)
export const DISPUTE_STATUS = {
  PENDING: 'pending',
  IN_REVIEW: 'in_review',
  RESOLVED: 'resolved',
  CANCELLED: 'cancelled'
};

// Limites pour les photos
export const PHOTO_LIMITS = {
  MAX_PHOTOS_PER_REPORT: 5,
  MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
  ALLOWED_FORMATS: ['jpg', 'jpeg', 'png', 'webp'],
  MAX_DESCRIPTION_LENGTH: 500
};

// Labels pour l'interface utilisateur
export const CONDITION_REPORT_LABELS = {
  TYPES: {
    [CONDITION_REPORT_TYPES.PICKUP]: 'Enlèvement',
    [CONDITION_REPORT_TYPES.RETURN]: 'Retour',
    [CONDITION_REPORT_TYPES.PICKUP_REFUSAL]: 'Refus d\'enlèvement',
    [CONDITION_REPORT_TYPES.RETURN_REFUSAL]: 'Refus de retour'
  },
  ACTIONS: {
    [CONDITION_ACTIONS.CONFIRM]: 'Confirmer',
    [CONDITION_ACTIONS.REFUSE]: 'Refuser',
    [CONDITION_ACTIONS.DISPUTE]: 'Contester'
  },
  PHOTO_TYPES: {
    [PHOTO_TYPES.EQUIPMENT_STATE]: 'État de l\'équipement',
    [PHOTO_TYPES.DAMAGE]: 'Dommage',
    [PHOTO_TYPES.ENVIRONMENT]: 'Environnement',
    [PHOTO_TYPES.REFUSAL_PROOF]: 'Preuve de refus',
    [PHOTO_TYPES.OVERVIEW]: 'Vue d\'ensemble',
    [PHOTO_TYPES.DETAIL]: 'Détail'
  },
  USER_ROLES: {
    [USER_ROLES.OWNER]: 'Propriétaire',
    [USER_ROLES.RENTER]: 'Locataire'
  },
  DISPUTE_STATUS: {
    [DISPUTE_STATUS.PENDING]: 'En attente',
    [DISPUTE_STATUS.IN_REVIEW]: 'En cours d\'examen',
    [DISPUTE_STATUS.RESOLVED]: 'Résolu',
    [DISPUTE_STATUS.CANCELLED]: 'Annulé'
  }
};

// Messages d'interface utilisateur
export const CONDITION_REPORT_MESSAGES = {
  UPLOAD: {
    SUCCESS: 'Photo ajoutée avec succès',
    ERROR: 'Erreur lors de l\'ajout de la photo',
    FILE_TOO_LARGE: `La taille du fichier ne peut pas dépasser ${PHOTO_LIMITS.MAX_FILE_SIZE / (1024 * 1024)}MB`,
    INVALID_FORMAT: `Format non supporté. Formats acceptés: ${PHOTO_LIMITS.ALLOWED_FORMATS.join(', ')}`,
    MAX_PHOTOS_REACHED: `Maximum ${PHOTO_LIMITS.MAX_PHOTOS_PER_REPORT} photos autorisées par rapport`
  },
  REPORT: {
    CREATED: 'Rapport d\'état créé avec succès',
    UPDATED: 'Rapport d\'état mis à jour avec succès',
    DELETED: 'Rapport d\'état supprimé avec succès',
    ERROR: 'Erreur lors de l\'opération sur le rapport',
    REFUSAL_REASON_REQUIRED: 'La raison du refus est obligatoire'
  },
  VALIDATION: {
    REQUIRED_FIELD: 'Ce champ est obligatoire',
    INVALID_UUID: 'Identifiant invalide',
    MAX_LENGTH_NOTES: 'Les notes ne peuvent pas dépasser 2000 caractères',
    MAX_LENGTH_REFUSAL: 'La raison de refus ne peut pas dépasser 1000 caractères',
    MAX_LENGTH_DESCRIPTION: `La description ne peut pas dépasser ${PHOTO_LIMITS.MAX_DESCRIPTION_LENGTH} caractères`
  }
};

// Configuration pour les composants
export const UI_CONFIG = {
  PHOTO_PREVIEW_SIZE: 150,
  PHOTO_THUMBNAIL_SIZE: 80,
  ANIMATION_DURATION: 300,
  MAX_TEXTAREA_ROWS: 4,
  DRAG_DROP_AREA_HEIGHT: 200
};

// Notes spéciales générées automatiquement par le système
export const SPECIAL_NOTES = {
  RETURN_CONFIRMED: 'return confirmé via modal enhanced',
  REFUSAL: 'Refus via modal enhanced',
  PICKUP_CONFIRMED: 'pickup confirmé via modal enhanced'
};

// Types spéciaux de condition reports pour traductions
export const SPECIAL_REPORT_TYPES = {
  PICKUP: 'pickup',
  RETURN: 'return',
  PICKUP_REFUSAL: 'pickup_refusal',
  RETURN_REFUSAL: 'return_refusal',
  DAMAGE_REPORT: 'damage_report',
  MAINTENANCE: 'maintenance'
};
